<script>
import {
  trainerComputed,
  trainerMethods,
  authMethods,
  adminPanelComputed,
  adminPanelMethods,
  clientMethods,
  authComputed,
  organizationComputed,
} from '@state/helpers';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    subscriptionDetails: {
      type: Object,
      required: false,
      default: () => {},
    },
    oneTimeDetails: {
      type: Object,
      required: false,
      default: () => {},
    },
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isInviting: false,
    };
  },
  computed: {
    ...adminPanelComputed,
    ...trainerComputed,
    ...authComputed,
    ...organizationComputed,
    firstName() {
      return this.client && this.client.profile && this.client.profile.firstName
        ? this.client.profile.firstName
        : 'Client';
    },
    isStripeCustomer() {
      return has(this.client.profile, 'stripe_id');
    },
    invitedToPlan() {
      return this.client &&
        this.client.profile &&
        !this.client.profile.subscribed &&
        this.client.profile.subscribed_plan
        ? this.currentUser &&
            this.currentUser.roles.isTrainer &&
            this.currentUser.trainer.myProducts[0].plans.find(
              (plan) => plan.id === this.client.profile.subscribed_plan
            )
        : this.client.invitation &&
            this.client.invitation.price_plan &&
            typeof this.client.invitation.price_plan === 'string' &&
            this.currentUser &&
            this.currentUser.roles.isTrainer &&
            this.currentUser.trainer.myProducts[0].plans.find(
              (plan) => plan.id === this.client.invitation.price_plan
            );
    },
    pendingPayment() {
      return (
        this.client &&
        this.client.profile &&
        this.client.invitation &&
        this.client.invitation.price_plan &&
        !this.client.profile.subscribed
      );
    },
    productName() {
      return this.isPlanActivated
        ? this.isRecurring
          ? `${this.subscriptionDetails.nickname} - ${this.intervalWeek}x/wk`
          : `${this.oneTimeDetails.nickname}`
        : this.invitedToPlan.type === 'recurring'
        ? `${this.invitedToPlan.nickname} - ${this.intervalWeek}x/wk`
        : this.invitedToPlan.nickname;
    },
    isRecurring() {
      return this.isPlanActivated
        ? !isEmpty(this.subscriptionDetails)
        : this.invitedToPlan.type === 'recurring';
    },
    isOneTime() {
      return !isEmpty(this.oneTimeDetails);
    },
    isPlanActivated() {
      return (
        this.client &&
        this.client.profile &&
        this.client.profile.subscribed &&
        this.client.profile.subscribed_plan &&
        this.client.profile.start_date &&
        this.client.profile.end_date &&
        this.client.profile.subscribed_plan !== null &&
        this.client.profile.subscribed_plan !== undefined &&
        this.client.profile.start_date !== null &&
        this.client.profile.start_date !== undefined &&
        this.client.profile.end_date !== null &&
        this.client.profile.end_date !== undefined
      );
    },
    intervalWeek() {
      return this.isPlanActivated
        ? this.isRecurring // Calc for activated plan
          ? this.subscriptionDetails &&
            this.subscriptionDetails.interval === 'week'
            ? this.subscriptionDetails.interval_count
            : this.subscriptionDetails &&
              this.subscriptionDetails.interval === 'month'
            ? this.subscriptionDetails.interval_count * 4
            : this.subscriptionDetails &&
              this.subscriptionDetails.interval === 'year'
            ? this.subscriptionDetails.interval_count * 52.143
            : 0
          : this.oneTimeDetails &&
            this.oneTimeDetails.metadata &&
            this.oneTimeDetails.metadata.access_length
          ? this.oneTimeDetails.metadata.access_length
          : 0
        : this.isRecurring // Calc if only invited to plan
        ? this.invitedToPlan && this.invitedToPlan.recurring.interval === 'week'
          ? this.invitedToPlan.recurring.interval_count
          : this.invitedToPlan.recurring &&
            this.invitedToPlan.recurring.interval === 'month'
          ? this.invitedToPlan.recurring.interval_count * 4
          : this.invitedToPlan.recurring &&
            this.invitedToPlan.recurring.interval === 'year'
          ? this.invitedToPlan.recurring.interval_count * 52.143
          : 0
        : this.invitedToPlan &&
          this.invitedToPlan.metadata &&
          this.invitedToPlan.metadata.access_length;
    },
    price() {
      return this.isPlanActivated
        ? this.isRecurring
          ? this.subscriptionDetails &&
            this.subscriptionDetails.amount &&
            this.subscriptionDetails.amount / 100
          : this.oneTimeDetails && this.oneTimeDetails.unit_amount
          ? this.oneTimeDetails.unit_amount / 100
          : 0
        : this.invitedToPlan.unit_amount / 100;
    },
    startDate() {
      return (
        this.client &&
        this.client.profile &&
        this.client.profile.start_date &&
        moment(this.client.profile.start_date).format('ll')
      );
    },
    endDate() {
      return (
        this.client &&
        this.client.profile &&
        this.client.profile.end_date &&
        moment(this.client.profile.end_date).format('ll')
      );
    },
    isInvited() {
      return (
        !isEmpty(this.client.invitation.sent_at) ||
        !isEmpty(this.client.invitation.reSent_at)
      );
    },
    isRegistered() {
      return (
        this.client.profile.lastSeen ||
        this.client.profile.last_seen ||
        (has(this.client.profile, 'successfulSignup') &&
          this.client.profile.successfulSignup)
      );
    },
  },
  methods: {
    ...adminPanelMethods,
    ...trainerMethods,
    ...authMethods,
    ...clientMethods,
    cancelSubcription() {
      const clientProduct = { label: 'productObj' };
      this.setSelectedProductItem({ ...clientProduct, context: 'cancel' });
      this.$bvModal.show('subscription-client-modal');
    },
    goToStripeDashboard() {
      window.location = this.currentUser.trainer.stripeLoginLink
        ? this.currentUser.trainer.stripeLoginLink
        : '#';
    },
    pauseSubcription() {
      const clientProduct = { label: 'productObj' };
      this.setSelectedProductItem({ ...clientProduct, context: 'pause' });
      this.$bvModal.show('subscription-client-modal');
    },
    revokeAccess() {
      const clientProduct = { label: 'productObj' };
      this.setSelectedProductItem({ ...clientProduct, context: 'revoke' });
      this.$bvModal.show('subscription-client-modal');
    },
    cancelRequest() {
      const clientPayload = cloneDeep(this.client);
      clientPayload.invitation.price_plan = null;
      this.updateClient({ clientObj: clientPayload });
    },
    async onInviteClient() {
      this.isInviting = true;
      const client = this.client;
      if (client) {
        const invitePayload = {
          client_id: client._id,
          trainer_id: client.trainer_id,
        };
        try {
          await this.inviteClient({ inviteObj: invitePayload });
        } catch (e) {
          console.log(e);
        }
        const updatedClient = await this.getClient({ clientObj: client });
        await this.setSelectedClient(updatedClient);
        await this.setUpdateClientItem(updatedClient);
        this.isInviting = false;
      }
    },
  },
};
</script>

<template>
  <div class="summary-block-container">
    <div v-if="isRecurring">
      <span class="title">Billing Summary</span>
      <div class="summary-block col-6">
        <div class="row product-name" v-if="productName !== 'undefined'">
          <label>product name</label>
          <span>{{ productName }}</span>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="col-9">
              <div class="earnings"
                ><span class="figure">{{ price }}</span
                ><span class="currency">$</span></div
              >
            </div>
          </div>
          <span v-if="startDate" class="divider-vertical">&nbsp;</span>
          <div v-if="startDate" class="col-4">
            <div class="col-9">
              <div class="start-date">
                <span class="subtitle">Start Date</span>
                <span class="figure">{{ startDate }}</span>
              </div>
            </div>
          </div>
          <div v-if="endDate" class="col-4">
            <div class="col-9">
              <div class="start-date">
                <span class="subtitle">End Date</span>
                <span class="figure">{{ endDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col ml-auto">
          <!-- TODO: enable when API is ready -->
          <!-- <BaseButton
            v-if="isPlanActivated"
            type="button"
            class="btn btn-secondary  btn-round btn-danger"
            @click="pauseSubcription"
          >
            Pause {{ organizationTitle }} PAY
          </BaseButton> -->
          <BaseButton
            v-if="isPlanActivated"
            type="button"
            class="btn btn-secondary  btn-round btn-danger"
            @click="cancelSubcription"
          >
            Cancel Subscription
          </BaseButton>
          <BaseButton
            v-if="isStripeCustomer"
            type="button"
            class="btn btn-secondary btn-round"
            @click="goToStripeDashboard"
          >
            Manage Client Billing
          </BaseButton>
          <div
            class="pending-payment"
            v-if="pendingPayment && (isInvited || isRegistered)"
            >Pending client payment...</div
          >
          <div
            class="pending-payment"
            v-if="!isPlanActivated && !isInvited && !isRegistered"
            >{{ firstName }} is not invited to {{ organizationTitle }} App yet
            <BaseButton
              :disabled="isInviting"
              type="button"
              class="btn-secondary btn-round invite"
              @click="onInviteClient"
            >
              <span v-if="!isInviting">Invite?</span>
              <BaseIcon v-if="isInviting" name="sync" spin /> </BaseButton
          ></div>
        </div>
      </div>
    </div>

    <div v-if="!isRecurring">
      <span class="title">Billing Summary</span>
      <div class="summary-block col-6">
        <div class="row product-name" v-if="productName !== 'undefined'">
          <label>product name</label>
          <span>{{ productName }}</span>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="col-9">
              <div class="earnings"
                ><span class="figure">{{ price }}</span
                ><span class="currency">$</span></div
              >
            </div>
          </div>
          <span class="divider-vertical">&nbsp;</span>
          <div class="col-3">
            <div class="col-9">
              <div class="earnings"
                ><span class="figure">{{ intervalWeek }}</span
                ><span class="currency">wk</span></div
              >
            </div>
          </div>
          <span v-if="startDate" class="divider-vertical">&nbsp;</span>
          <div v-if="startDate" class="col-3">
            <div class="col-9">
              <div class="start-date">
                <span class="subtitle">Start Date</span>
                <span class="figure">{{ startDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col ml-auto">
          <BaseButton
            v-if="isPlanActivated"
            type="button"
            class="btn-secondary btn-round btn-danger"
            @click="revokeAccess"
          >
            Revoke Access
          </BaseButton>
          <div
            class="pending-payment-wrapper"
            v-if="pendingPayment && (isInvited || isRegistered)"
          >
            <div class="pending-payment">Pending client payment...</div>
            <div
              class="pending-payment"
              v-if="!isPlanActivated && !isInvited && !isRegistered"
              >{{ firstName }} is not invited to {{ organizationTitle }} App yet
              <BaseButton
                :disabled="isInviting"
                type="button"
                class="btn-secondary btn-round invite"
                @click="onInviteClient"
              >
                <span v-if="!isInviting">Invite?</span>
                <BaseIcon v-if="isInviting" name="sync" spin /> </BaseButton
            ></div>
            <BaseButton
              type="button"
              class="btn btn-secondary  btn-round btn-danger"
              @click="cancelRequest"
            >
              Cancel Request
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.summary-block-container {
  margin-top: 2rem;
  width: 100%;
  .title {
    color: $color-black-one;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.466667px;
    line-height: 32px;
    margin-bottom: 2rem;
    position: absolute;
    top: -1.8rem;
  }
  .ml-auto {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding-bottom: 3rem;
    .pending-payment {
      align-items: center;
      color: $color-danger;
      display: flex;
      font-size: 1.5rem;
      font-weight: 600;
    }
    .button {
      border: 2px solid $color-danger;
      font-size: 1.6rem;
      margin-right: 2rem;
      padding-bottom: 1.2rem;
      padding-top: 1.2rem;
      &.invite {
        align-items: center;
        border: 2px solid $color-action;
        display: flex;
        flex-direction: column;
        font-size: 1.3rem;
        height: 2rem;
        justify-content: center;
        margin-left: 2rem;
        width: 9rem;
      }
    }
  }
}

.summary-block {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba($color-black-wo-rgb, 0.08);
  margin-top: 2rem;
  position: relative;
  .product-name {
    align-items: flex-start !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: unset !important;
    span {
      font-size: 38px;
      font-style: normal;
      font-weight: bold;
      line-height: 46px;
      text-transform: capitalize;
    }
  }

  .pending-payment-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .row {
    align-items: center;
    height: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 2.5rem 2rem;
    .col-3 {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: flex-start;
      .figure {
        color: $color-black-one;
        font-size: 36px;
        font-style: normal;
        font-weight: normal;
        letter-spacing: -2.76429px;
        line-height: 50px;
      }
      .subtitle {
        color: $color-dark-gray-four;
        font-size: 12px;
        font-style: normal;
        font-weight: 800;
        letter-spacing: 0.1px;
        line-height: 22px;
        text-transform: uppercase;
        white-space: nowrap;
        @include calc-font-size(0.7);
      }
      &:first-child {
        flex: 0 0 20%;
        max-width: 20%;
        padding-left: unset;
      }
      .col-9 {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-left: unset;
        .earnings {
          white-space: nowrap;
        }
        .start-date {
          display: flex;
          flex-direction: column;
          .figure {
            color: $color-black-one;
            font-size: 18px;
            font-style: normal;
            font-weight: normal;
            letter-spacing: 0.275px;
            line-height: 21px;
            margin-top: 1rem;
            white-space: nowrap;
          }
          .subtitle {
            color: $color-dark-gray-four;
            font-size: 12px;
            font-style: normal;
            font-weight: 800;
            letter-spacing: 0.1px;
            line-height: 22px;
            text-transform: uppercase;
          }
        }
      }

      .currency {
        color: $color-black-one;
        font-size: 18px;
        font-style: normal;
        font-weight: normal;
        letter-spacing: 0.275px;
        line-height: 21px;
        margin-left: 3px;
      }
    }
    .col-4 {
      margin-left: 1rem;
      @extend .col-3;
    }
  }
  .divider-vertical {
    border-left: 1px solid $color-gray;
    height: 5rem;
    opacity: 0.5;
  }
}
</style>
